/**
 * @desc Wrapper for failsafe usage of dataLayer
 * @usage `import {dataLayer} from 'shared'`  `dataLayer.push(...)`
 * */

export const dataLayer = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  push: /** @param {*} args */ (args: any) => window?.dataLayer?.push?.(args),
}
